import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { PUBLISH_APPROVAL, PUBLISH_APPROVAL_SUCCESS, PUBLISH_APPROVAL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* publishApproval({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/configurations/benefit-type/airport-transfer/publish`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: PUBLISH_APPROVAL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: PUBLISH_APPROVAL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PUBLISH_APPROVAL_ERROR, payload: error });
  }
}

export function* watchpublishApproval() {
  yield takeEvery(PUBLISH_APPROVAL, publishApproval);
}

function* publishApprovalSaga() {
  yield all([fork(watchpublishApproval)]);
}

export default publishApprovalSaga;
